import { NodeRange } from 'prosemirror-model'
import { type EditorState, type Transaction } from 'prosemirror-state'
import { type Mapping } from 'prosemirror-transform'

export enum CommandName {
  BREAK_OUT_OF_LIST = 'breakOutOfList',
  PULL_NEXT_ITEM = 'pullNextItem',
  SPLIT_BLOCK = 'splitBlock',
  JOIN_BACKWARD = 'joinBackward',
  SPLIT_LIST_ITEM_ON_GAP_CURSOR = 'splitListItemOnGapCursor',
  LIFT_EMPTY_BLOCK = 'liftEmptyBlock',
}

interface BaseTrackedChangeCommand {
  name: CommandName
}

export interface BreakOutOfListTrackedChangeCommand extends BaseTrackedChangeCommand {
  name: CommandName.BREAK_OUT_OF_LIST
  meta: {
    from: number
    to: number
  }
}

export interface PullNextItemCommand extends BaseTrackedChangeCommand {
  name: CommandName.PULL_NEXT_ITEM
  meta: {
    targetNodePos: number
  }
}

export interface SplitBlockCommand extends BaseTrackedChangeCommand {
  name: CommandName.SPLIT_BLOCK
}

export interface JoinBackwardCommand extends BaseTrackedChangeCommand {
  name: CommandName.JOIN_BACKWARD
}

export interface SplitListItemOnGapCursorCommand extends BaseTrackedChangeCommand {
  name: CommandName.SPLIT_LIST_ITEM_ON_GAP_CURSOR
}

export interface LiftEmptyBlockCommand extends BaseTrackedChangeCommand {
  name: CommandName.LIFT_EMPTY_BLOCK
  meta: {
    target: number
    range: NodeRange
  }
}

export type TrackedChangeCommand =
  | BreakOutOfListTrackedChangeCommand
  | PullNextItemCommand
  | SplitBlockCommand
  | JoinBackwardCommand
  | SplitListItemOnGapCursorCommand
  | LiftEmptyBlockCommand

export interface CommandTrackerProps {
  originalTr: Transaction
  wrappedTr: Transaction
  map: Mapping
  state: EditorState
  userId: number
}

export type TrackedChangesCommandHandler = (props: CommandTrackerProps) => boolean
